import React, { useEffect } from "react";

/**
 * Shared right-side detail drawer used by the registers.
 * Pure presentational; the parent owns open/close state.
 */
export function DetailDrawer({ open, onClose, title, subtitle, children, testid = "detail-drawer" }) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid={`${testid}-backdrop`}
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(20,20,20,0.32)",
        zIndex: 50, backdropFilter: "blur(2px)",
      }}
    >
      <aside
        data-testid={testid}
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "absolute", top: 0, right: 0, bottom: 0,
          width: "min(640px, 92vw)",
          background: "var(--surface)",
          borderLeft: "1px solid var(--line)",
          boxShadow: "-12px 0 32px rgba(0,0,0,0.06)",
          display: "flex", flexDirection: "column",
        }}
      >
        <header style={{
          padding: "18px 22px",
          borderBottom: "1px solid var(--line)",
          display: "flex", alignItems: "flex-start", gap: 12,
        }}>
          <div style={{ flex: 1 }}>
            <div className="heading h2" style={{ marginBottom: 2 }}>{title}</div>
            {subtitle && <div className="muted" style={{ fontSize: 12 }}>{subtitle}</div>}
          </div>
          <button
            className="btn btn-sm" data-testid={`${testid}-close`} onClick={onClose}
          >Close</button>
        </header>
        <div style={{ flex: 1, overflowY: "auto", padding: "18px 22px" }}>
          {children}
        </div>
      </aside>
    </div>
  );
}
